import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from "@angular/core";
import {AuthService} from '../services/infrastructure/auth.service';
import {CookiesService} from '../services/infrastructure/cookies.service';


export const tokenInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  const authService: AuthService = inject(AuthService);
  const c = inject(CookiesService);
  const token = c.getToken();

  if (token) {
    request = request.clone({
      setHeaders: {
        'Authorization': 'Bearer ' + token,
      }
    });
  }

  return next(request);
}
